import { BlockLayout, BlocksColumn, BlocksRow } from '~/components/layouts';
import UploadDrop from '../UploadDrop';
import PNLChart from './PNLChart';
import IncomesChart from './IncomesChart';
import ExpensesChart from './ExpensesChart';
import { useState } from 'react';

const Dashboard = () => {
  const [ selectedMonth, setSelectedMonth ] = useState(null);

  const setMonth = (month) => {
    if (selectedMonth !== month) {
      setSelectedMonth(month);
    }
  };

	return (
    <>

      <BlocksRow>

        <BlocksColumn size={6}>

          <BlocksRow>

            <BlocksColumn size={8}>
              <BlockLayout title={`PNL Chart`}>
                <PNLChart setMonth={setMonth} />
              </BlockLayout>
            </BlocksColumn>

          </BlocksRow>
          
          <BlocksRow>

            <BlocksColumn size={4}>
              <BlockLayout title={selectedMonth ? `Incomes (${selectedMonth}月)` : `Incomes`}>
                <IncomesChart month={selectedMonth} />
              </BlockLayout>
            </BlocksColumn>

            <BlocksColumn size={4}>
            <BlockLayout title={selectedMonth ? `Expenses (${selectedMonth}月)` : `Expenses`}>
                <ExpensesChart month={selectedMonth} />
              </BlockLayout>
            </BlocksColumn>

          </BlocksRow>

        </BlocksColumn>

        <BlocksColumn size={2}>

          <BlockLayout title='Upload Invoices'>
            <UploadDrop mode='invoices' text='Drop your invoices here' />
          </BlockLayout>

          <BlockLayout title='Upload Expenses'>
            <UploadDrop mode='expenses' text='Drop your expenses here' />
          </BlockLayout>

          <BlockLayout title='Reminders'>
          </BlockLayout>

          <BlockLayout title='Balance'>
          </BlockLayout>

        </BlocksColumn>

      </BlocksRow>

    </>
	);
};

export default Dashboard;